import { memo } from 'react'
import { isEqual } from 'lodash'
import UnitManagementContainer from 'app/containers/UnitManagement'
import { PageTitle } from 'app/components/common/PageTitle'
import { useTranslation } from 'react-i18next'
import R from 'app/assets/R'

const UnitManagementCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.unit_management)}</PageTitle>
      <UnitManagementContainer />
    </>
  )
}
export const UnitManagementPage = memo(UnitManagementCpn, isEqual)
